export default "__VITE_ASSET__8cc4a8a5__"